<template>
    <div class="update-mgt-page">
        <div class="global-header-wrap">
            <span>{{ $t("commonMsg.detail") }}</span>
            <div>
                <button class="global-button-style" @click="$router.back()">
                    {{ $t("commonMsg.back") }}
                </button>
            </div>
        </div>
        <el-card
                class="app-table-container"
                :body-style="{ padding: '20px' }"
                v-bar
        >
            <div class="body-wrap">
                <el-form
                        label-width="120px"
                        :model="update"
                        @submit.native.prevent
                        ref="ruleForm"
                >
                    <el-form-item :label="$t('update.title')" prop="title">
                        <el-input
                                v-model="update.title"
                                class="fl"
                                disabled
                                style="width: 200px"
                        ></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('update.introduce')">
                        <div v-html="update.description" class="introduce-wrap"></div>
                    </el-form-item>
                </el-form>
            </div>
        </el-card>
    </div>
</template>

<script>
    import OSS from "ali-oss";

    export default {
        data() {
            return {
                update: {
                    title: "",
                    description: ""
                }
            };
        },
        created() {
            this.getAppDetails();
        },
        methods: {
            getAppDetails() {
                this.$http.getUpdateDetails(this.$route.query.id).then(res => {
                    this.update = Object.assign({}, res.data);
                });
            }
        }
    };
</script>

<style lang="scss">
    .update-mgt-page {
        height: 100%;
        display: flex;
        flex-direction: column;
        .body-wrap {
            /* height: 100%; */
            flex: 1;
            overflow: hidden;
            .el-form {
                width: 80%;
                margin: 10px auto;
                .global-button-style {
                    width: 100%;
                    margin: 0;
                }
                .update-import-btn {
                    margin-top: 10px;
                }
                .update-upload-progress {
                    display: flex;
                    align-items: center;
                    > .el-progress__text {
                        /* width: 100px; */
                    }
                }
            }
        }
    }
    .introduce-wrap {
        border: 1px solid #E4E7ED;
        border-radius: 3px;
        background-color: #f5f7fa;
        padding: 3px 10px;
    }
</style>
